import React, { useEffect, useState } from 'react';
import { ReactTable } from '../../components/Placeholder';
import { useMutation, useQuery } from '@apollo/client';
import { GET_AUTHOR_FAV } from '@core/ui/graphql/Author';
import { UPDATE_MASS_FAV } from '@core/ui/graphql/Mutations';
import { useRouter } from 'next/router';
import OnError from '../../components/OnError';
import { get, isEmpty, sortBy } from 'lodash';
import Empty from '../../components/Empty';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import searchIcon from '@core/ui/static/images/ico-search.svg';
import Button from 'reusecore/src/elements/Button';
import { useTranslation } from 'next-i18next';
import Icon from 'react-icons-kit';
import { androidDelete } from 'react-icons-kit/ionicons/androidDelete';
import Table from '../../components/Table';
import { ButtonWrapper, AdsWrapper } from './style';
import {
  RenderAction,
  RenderDate,
  renderImage,
  RenderPrice,
  RenderTitle,
} from '../../components/Renderer/ads';
import { useToasts } from 'react-toast-notifications';
import { LoaderOpacity } from '../../components/LoadingIndicator/LoadingIndicator.style';
import { SpinnerLoader } from '../../components/Loader/spinnerLoader';

const Fav = ({ favorites, isLoggedIn, userId }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const [favList, setFavList] = useState([]);
  const [skip, setSkip] = useState(false);
  const [isFetching, setFetching] = useState(false);
  const { addToast } = useToasts();

  // QUERY SECTION
  let QUERY_VARIABLES = {
    favorites: favorites,
    LIMIT: 50,
  };
  const { data, loading, error } = useQuery(GET_AUTHOR_FAV, {
    variables: QUERY_VARIABLES,
    ssr: false,
    skip
  });
  const [favoriteMutation] = useMutation(UPDATE_MASS_FAV);

  const { favorites: userFavorites } = data || {};

  useEffect(() => {
    if (userFavorites && !loading) {
      if (userFavorites.data.length > 0) {
        setFavList(sortAds(userFavorites.data));
        setSkip(true);
      } else {
        setFavList([]);
      }
    }
  }, [userFavorites]);

  const sortAds = data => {
    return sortBy(data, o => -o.createdAt._seconds);
  };

  const cta = (
    <Button
      title={t('profile.favorites.empty.btn')}
      onClick={() => router.push(`/${SEARCH_PAGE}/all`)}
      icon={<img src={searchIcon} alt={t('profile.favorites.empty.btn')} />}
      iconPosition="left"
      bg="#00BCD4"
      color="#FFF"
      border="1px solid #00BCD4"
      aria-label={t('profile.favorites.empty.btn')}
    />
  );

  let keys = [];

  const onSelect = ids => {
    keys = ids;
  };

  const deleteFavourites = async ids => {
    if (isEmpty(ids)) {
      addToast(t('profile.favorites.delete.empty'), {
        appearance: 'warning',
        autoDismiss: true,
      });
      return;
    }
    if (isLoggedIn) {
      setFetching(true);
      await favoriteMutation({
        variables: {
          fav: { ids },
        },
      });
      setFavList(favList.filter(fav => ids.indexOf(fav.id) === -1));
      setFetching(false);
    }
  };

  const columns = [
    {
      Header: (
        <ButtonWrapper>
          <span onClick={() => deleteFavourites(keys)} className="btn delete">
            <Icon size={25} mr={10} icon={androidDelete} /> {t('delete')}
          </span>
        </ButtonWrapper>
      ),
      accessor: 'image',
    },
    {
      Header: '',
      accessor: 'title',
    },
    {
      Header: t('publishView.price'),
      accessor: 'price',
    },
    {
      Header: t('creationDate'),
      accessor: 'createdAt',
    },
    {
      Header: <span style={{ marginLeft: '5%' }}>{t('action')}</span>,
      accessor: 'action',
    },
  ];

  const favoritesData = [];
  favList.forEach(element => {
    const actions = [
      <a className="delete" onClick={() => deleteFavourites([element.id])}>
        {t('profile.favorites.delete.action')}
      </a>,
    ];
    favoritesData.push({
      key: element.id,
      image: renderImage(element),
      title: <RenderTitle element={element} />,
      price: <RenderPrice element={element} />,
      createdAt: <RenderDate element={element} />,
      action: <RenderAction actions={actions} />,
    });
  });

  if (error) {
    return <OnError />;
  }

  // Post Loop Control Area
  return (
    <AdsWrapper>
      {!loading && get(data, 'favorites.data', {}).length === 0 ? (
        <Empty
          title={t('profile.favorites.empty.title')}
          description={t('profile.favorites.empty.save')}
          extra={cta}
        />
      ) : loading ? (
        <>
          <ReactTable />
          <SpinnerLoader className="mobile" />
        </>
      ) : (
        <>
          {isFetching && <LoaderOpacity />}
          <Table
            className="responsive"
            columns={columns}
            data={favoritesData}
            onSelect={onSelect}
          />
        </>
      )}
    </AdsWrapper>
  );
};

export default Fav;
